import React from 'react';
import PropTypes from 'prop-types';
import Banner from './Banner';

export const RECONVENE_HEADER = 'The event for event creators is here';

const ReconveneBanner = (props) => {
    const trackingData = {
        type: 'TRACK_RECONVENE_BANNER_CLICK_REGISTER_NOW',
        meta: {
            analytics: {
                action: 'RECONVENEBannerClickRegisterNow',
                category: props.category,
            },
        },
    };

    const destinationURL =
        'https://www.eventbrite.com/reconvene/?aff=homepage1';

    return (
        <Banner
            leftAccentColor="#F05537"
            style="dark"
            header={RECONVENE_HEADER}
        >
            <span>
                Introducing RECONVENE, a free, two-day virtual networking and
                skillsharing summit about the future of events.{' '}
                <a
                    onClick={() => {
                        props.handleTracking(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL}
                >
                    Register now
                </a>{' '}
                to explore where the industry is heading — and where you’d like
                to take it.
            </span>
        </Banner>
    );
};

ReconveneBanner.propTypes = {
    handleTracking: PropTypes.func,
    trackingParams: PropTypes.string,
    category: PropTypes.string,
};

export default ReconveneBanner;
